<template>
  <div class="site-settings-view sticky relative overflow-y-auto h-[calc(100vh-50px)]">
    <BlocksNavigationHeader />
    <BlocksNavigationList />
  </div>
</template>

<script setup lang="ts"></script>
